import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-textfield-background-color: var(--sds-textfield-background-color, var(--sds-color-background-default, var(--sds-color-neutral-background-default)));
		--_sds-textfield-text-color: var(--sds-textfield-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));

		--_sds-textfield-border-color: var(--sds-textfield-border-color, var(--sds-color-border-default, var(--sds-color-neutral-border-default)));
		--_sds-textfield-border-width: var(--sds-textfield-border-width, var(--sds-border-sm));
		--_sds-textfield-border-radius: var(--sds-textfield-border-radius, var(--sds-radius-sm));

		--_sds-textfield-font-family: var(--sds-textfield-font-family, var(--sds-typography-font-family-roboto));
		--_sds-textfield-font-size: var(--sds-textfield-font-size, var(--sds-components-font-size-content-md));
		--_sds-textfield-font-weight: var(--sds-textfield-font-weight, var(--sds-typography-font-weight-regular));
		--_sds-textfield-line-height: var(--sds-textfield-line-height, var(--sds-components-line-height-squeezed-md));
		--_sds-textfield-min-height: var(--sds-textfield-height, var(--sds-components-button-md));

		--_sds-textfield-gap: var(--sds-textfield-gap, var(--sds-spacing-3xs));
		--_sds-textfield-padding-block: var(--sds-textfield-padding-block, 0);
		--_sds-textfield-padding-inline: var(--sds-textfield-padding-inline, var(--sds-spacing-xs));
		--_sds-textfield-padding-icon: var(--sds-textfield-padding-icon, calc(var(--sds-spacing-xs) + var(--sds-components-icon-md)));
		--_sds-textfield-disabled-opacity: var(--sds-textfield-disabled-opacity, var(--sds-color-states-disabled-opacity));
		--_sds-textfield-max-width: var(--sds-textfield-input-max-width, var(--sds-typography-max-line-width, 60ch));

		--_sds-textfield-label-text-color: var(--sds-textfield-label-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));
		--_sds-textfield-label-font-size: var(--sds-textfield-label-font-size, var(--sds-components-font-size-content-md));
		--_sds-textfield-label-font-weight: var(--sds-textfield-label-font-weight, var(--sds-typography-font-weight-medium));
		--_sds-textfield-label-line-height: var(--sds-textfield-label-line-height, var(--sds-components-line-height-squeezed-md));

		--_sds-textfield-helptext-text-color: var(--sds-textfield-helptext-text-color, var(--sds-color-text-subtle, var(--sds-color-neutral-text-subtle)));
		--_sds-textfield-helptext-font-size: var(--sds-textfield-helptext-font-size, var(--sds-components-font-size-content-md));
		--_sds-textfield-helptext-font-weight: var(--sds-textfield-helptext-font-weight, var(--sds-typography-font-weight-regular));
		--_sds-textfield-helptext-line-height: var(--sds-textfield-helptext-line-height, var(--sds-components-line-height-squeezed-md));

		--_sds-textfield-focus-color: var(--sds-textfield-focus-color, var(--sds-color-states-focus-outer));
		--_sds-textfield-focus-inner-color: var(--sds-textfield-focus-inner-color, var(--sds-color-states-focus-inner));
		--_sds-textfield-focus-spacing: var(--sds-textfield-focus-spacing, var(--sds-color-states-focus-spacing));

		--_sds-textfield-icon-right: var(--sds-textfield-icon-right, var(--sds-spacing-xs));
		--_sds-textfield-icon-top: var(--sds-textfield-icon-top, var(--sds-spacing-3xs));

		all: unset;
		display: block;
		text-align: start;
	}

	.sds-textfield {
		display: flex;
		flex-direction: column;
		gap: var(--_sds-textfield-gap);
		font-family: var(--_sds-textfield-font-family);

		.sds-textfield__input-container {
			position: relative;
			font-size: var(--_sds-textfield-font-size);
			max-width: var(--_sds-textfield-max-width);
		}

		.sds-textfield__input {
			box-sizing: border-box;
			color: var(--_sds-textfield-text-color);
			padding: var(--_sds-textfield-padding-block) var(--_sds-textfield-padding-inline);
			line-height: var(--_sds-textfield-line-height);
			font-size: var(--_sds-textfield-font-size);
			font-weight: var(--_sds-textfield-font-weight);
			font-family: var(--_sds-textfield-font-family);
			min-height: var(--_sds-textfield-min-height);
			border-radius: var(--_sds-textfield-border-radius);
			border: var(--_sds-textfield-border-width) solid var(--_sds-textfield-border-color);
			background: var(--_sds-textfield-background-color);
			width: 100%;

			&:hover {
				--_sds-textfield-border-color: var(--sds-textfield-border-color, var(--sds-color-border-strong, var(--sds-color-neutral-border-strong)));
			}

			&:focus-visible {
				box-shadow: 0 0 0 var(--sds-color-states-focus-spacing) var(--_sds-textfield-focus-inner-color);
				outline: 3px solid var(--_sds-textfield-focus-color);
				outline-offset: 3px;
			}
		}

		.sds-textfield__label {
			color: var(--_sds-textfield-text-color);
			font-size: var(--_sds-textfield-label-font-size);
			font-weight: var(--_sds-textfield-label-font-weight);
			line-height: var(--_sds-textfield-label-line-height);
		}

		.sds-textfield__label:has(sds-icon) {
			display: flex;
			flex-direction: row;
			align-items: center;
			gap: var(--_sds-textfield-gap);
		}

		.sds-textfield__help-text {
			display: block;
			color: var(--_sds-textfield-helptext-text-color);
			font-size: var(--_sds-textfield-helptext-font-size);
			font-weight: var(--_sds-textfield-helptext-font-weight);
			line-height: var(--_sds-textfield-helptext-line-height);
			margin: 0;
		}
	}

	.sds-textfield--error {
		--_sds-textfield-border-color: var(--sds-textfield-border-color, var(--sds-color-alert-danger-border-default));

		& .sds-textfield__input:hover,
		& .sds-textfield__input:hover {
			--_sds-textfield-border-color: var(--sds-textfield-border-color, var(--sds-color-alert-danger-border-default));
		}
	}

	:host([readonly]) {
		--_sds-textfield-background-color: var(--sds-textfield-background-color, var(--sds-color-surface-tinted, var(--sds-color-neutral-surface-tinted)));
	}

	:host([disabled]) {
		opacity: var(--_sds-textfield-disabled-opacity);
		pointer-events: none;
	}

	.sds-textfield--has-icon {
		.sds-textfield__input {
			padding-right: var(--_sds-textfield-padding-icon);
		}
	}

	::slotted([slot='after']) {
		position: absolute;
		top: var(--_sds-textfield-icon-top);
		right: var(--_sds-textfield-icon-right);
		pointer-events: none;
	}

	:host([size='sm']) {
		--_sds-textfield-min-height: var(--sds-textfield-height, var(--sds-components-button-sm));
		--_sds-textfield-font-size: var(--sds-textfield-font-size, var(--sds-components-font-size-content-sm));
		--_sds-textfield-line-height: var(--sds-textfield-line-height, var(--sds-components-line-height-squeezed-sm));
		--_sds-textfield-label-font-size: var(--sds-textfield-label-font-size, var(--sds-components-font-size-content-sm));
		--_sds-textfield-label-line-height: var(--sds-textfield-label-line-height, var(--sds-components-line-height-squeezed-sm));
		--_sds-textfield-helptext-font-size: var(--sds-textfield-helptext-font-size, var(--sds-components-font-size-content-sm));
		--_sds-textfield-helptext-line-height: var(--sds-textfield-helptext-line-height, var(--sds-components-line-height-squeezed-sm));
		--_sds-textfield-icon-top: var(--sds-textfield-icon-top, calc((var(--_sds-textfield-min-height) - var(--sds-components-icon-sm)) / 2));
		--_sds-textfield-padding-icon: var(--sds-textfield-padding-icon, calc(var(--sds-spacing-xs) + var(--sds-components-icon-sm)));

		&:has(sds-icon:not([size])) {
			--sds-icon-size: var(--sds-textfield-icon-size, var(--sds-components-icon-sm));
		}
	}

	:host([size='lg']) {
		--_sds-textfield-min-height: var(--sds-textfield-height, var(--sds-components-button-lg));
		--_sds-textfield-font-size: var(--sds-textfield-font-size, var(--sds-components-font-size-content-lg));
		--_sds-textfield-line-height: var(--sds-textfield-line-height, var(--sds-components-line-height-squeezed-lg));
		--_sds-textfield-label-font-size: var(--sds-textfield-label-font-size, var(--sds-components-font-size-content-lg));
		--_sds-textfield-label-line-height: var(--sds-textfield-label-line-height, var(--sds-components-line-height-squeezed-lg));
		--_sds-textfield-helptext-font-size: var(--sds-textfield-helptext-font-size, var(--sds-components-font-size-content-lg));
		--_sds-textfield-helptext-line-height: var(--sds-textfield-helptext-line-height, var(--sds-components-line-height-squeezed-lg));
		--_sds-textfield-icon-top: var(--sds-textfield-icon-top, var(--sds-spacing-3xs));
		--_sds-textfield-padding-icon: var(--sds-textfield-padding-icon, calc(var(--sds-spacing-xs) + var(--sds-components-icon-lg)));

		&:has(sds-icon:not([size])) {
			--sds-icon-size: var(--sds-textfield-icon-size, var(--sds-components-icon-lg));
		}
	}
`;
